import { useState } from "react";
import { Form } from "react-bootstrap";
import { faPlus, faPhone, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContactForm from "../Form/ContactForm";
import ErrorPopup from "../../../../../layout/ErrorPopup";
import CrmConfig from "@serie3/freelancesplaceapi/Config/Crm/CrmConfig";
import crudApi from "@serie3/common/api/crudApi";
import listHandler from "@serie3/common/Domain/listHandler";

const ContactRow = ({ index, item, onEdit, onDelete }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 14px", borderRadius: "10px", background: "#f8f9fb",
    marginBottom: "8px", gap: "12px",
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
      <div style={{
        width: "34px", height: "34px", borderRadius: "8px", flexShrink: 0,
        background: "#e8f0fe", display: "flex", alignItems: "center",
        justifyContent: "center", color: "#1a73e8", fontSize: "0.85rem",
      }}>
        <FontAwesomeIcon icon={faPhone} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: "0.72rem", fontWeight: 700, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "2px" }}>
          {item.key_name}
        </div>
        <div style={{ fontSize: "0.92rem", fontWeight: 600, color: "#212121", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {item.value}
        </div>
      </div>
    </div>
    <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
      <button type="button" onClick={onEdit}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#9e9e9e", padding: "5px 7px", borderRadius: "6px", fontSize: "0.75rem", transition: "color 0.15s, background 0.15s" }}
        onMouseOver={e => { e.currentTarget.style.color = "#1a73e8"; e.currentTarget.style.background = "#e8f0fe"; }}
        onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
      ><FontAwesomeIcon icon={faPen} /></button>
      <button type="button" onClick={onDelete}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#9e9e9e", padding: "5px 7px", borderRadius: "6px", fontSize: "0.75rem", transition: "color 0.15s, background 0.15s" }}
        onMouseOver={e => { e.currentTarget.style.color = "#c62828"; e.currentTarget.style.background = "#ffebee"; }}
        onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
      ><FontAwesomeIcon icon={faTrash} /></button>
    </div>
  </div>
);

const Contacts = ({ contactData, companyId, setContactData, personId }) => {
  const [showEdit, setShowEdit] = useState(false);
  const [editContact, setEditContact] = useState(null);
  const [showError, setShowError] = useState(false);

  const deleteItem = (index, item) => {
    listHandler.deleteFromList(index, crudApi.del(CrmConfig.contactData.endpoints.delete, item.id), setContactData, contactData, () => setShowError(true));
  };

  return (
    <>
      <ErrorPopup setShowError={setShowError} showError={showError}>
        Sorry! Something went wrong. <strong>Please contact support if this persists.</strong>
      </ErrorPopup>

      <Form>
        <ContactForm
          showEdit={showEdit}
          setShowEdit={setShowEdit}
          editContact={editContact}
          companyId={companyId}
          personId={personId}
          dataList={contactData}
          setContactData={setContactData}
          showErrorFunction={() => setShowError(true)}
        />
      </Form>

      <div style={{ padding: "0 4px" }}>
        {contactData && contactData.length > 0 ? (
          contactData.map((item, index) => (
            <ContactRow
              key={index}
              index={index}
              item={item}
              onEdit={() => { setEditContact(item); setShowEdit(true); }}
              onDelete={() => deleteItem(index, item)}
            />
          ))
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 20px", color: "#bdbdbd" }}>
            <FontAwesomeIcon icon={faPhone} style={{ fontSize: "2rem", marginBottom: "10px" }} />
            <span style={{ fontSize: "0.9rem" }}>No contact info yet</span>
          </div>
        )}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 4px 4px" }}>
        <button
          type="button"
          onClick={() => { setEditContact(null); setShowEdit(true); }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            padding: "8px 16px", background: "#e8f5e9", color: "#2e7d32",
            border: "none", borderRadius: "10px", fontWeight: 700,
            fontSize: "0.85rem", cursor: "pointer", transition: "background 0.15s",
          }}
          onMouseOver={e => e.currentTarget.style.background = "#c8e6c9"}
          onMouseOut={e => e.currentTarget.style.background = "#e8f5e9"}
        >
          <FontAwesomeIcon icon={faPlus} style={{ fontSize: "0.75rem" }} />
          Add Contact
        </button>
      </div>
    </>
  );
};

export default Contacts;
